import React from "react"
import Autocomplete from "@mui/material/Autocomplete"
import { TextField } from "@mui/material"
import moment from "moment"

const CustomAutocomplete = (props) => {
    const {
        items,
        dates = [], // массив Date или строк ISO
        label,
        multiple = false,
        error,
        setValue,
        name,
        value,
        defaultValue = null
    } = props

    // Преобразуем dates в объекты, совместимые с items
    const dateOptions = dates.map((d) => ({
        // уникальный ключ для сравнения
        _id: typeof d === "string" ? d : d.toISOString(),
        // сохраняем дату
        date: d
    }))

    // Собираем все опции
    const options = [...items, ...dateOptions]

    // Функция, чтобы из option получить строку для отображения
    const getOptionLabel = (option) => {
        if (option.name) return option.name // у вас для объектов
        if (option.title) return option.title
        if (option.date) {
            // option.date может быть Date или строкой
            return moment(option.date).format("DD.MM.YYYY")
        }
        return ""
    }

    // Сравниваем выбранное значение и опцию
    const isOptionEqualToValue = (option, val) => {
        // для объектов по _id
        if (option._id && val._id) return option._id === val._id
        // для дат — по таймстемпу
        if (option.date && val.date) {
            return moment(option.date).valueOf() === moment(val.date).valueOf()
        }
        return false
    }

    const material = {
        background: "transparent",
        color: "white",
        "& label.Mui-focused": { color: "#FF5500" },
        "& input::placeholder": { color: "white" },
        "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline": {
            borderColor: "#FF5500"
        },
        "& .MuiOutlinedInput-root": {
            borderRadius: 0,
            color: "white"
        },
        "& .MuiOutlinedInput-notchedOutline": {
            borderColor: "rgba(255, 85, 0, .3)"
        },
        "& .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline": {
            borderColor: "rgba(255, 85, 0, .6)"
        },
        "& .MuiFormHelperText-root.Mui-error": {
            margin: 0,
            marginTop: "10px"
        },
        "& .MuiInputLabel-root": {
            color: "gray"
        },
        "& svg": {
            color: "rgba(255, 255, 255, .4)"
        }
    }

    return (
        <Autocomplete
            disablePortal
            options={options}
            value={value}
            getOptionLabel={getOptionLabel}
            onChange={(e, newVal) => setValue(name, newVal)}
            multiple={multiple}
            filterSelectedOptions
            limitTags={10}
            isOptionEqualToValue={isOptionEqualToValue}
            style={{ width: "100%" }}
            defaultValue={defaultValue}
            renderInput={(params) => (
                <TextField
                    {...params}
                    sx={material}
                    label={label}
                    error={!!error}
                    helperText={error ? error.message : null}
                />
            )}
            sx={{
                "& .MuiChip-root": {
                    backgroundColor: "#e45006",
                    color: "white"
                }
            }}
        />
    )
}

export default CustomAutocomplete
